import React, { useState } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import RoleLoginForm from "../../components/RoleLoginForm/RoleLoginForm";
import _BankAdminService from "../../modules/BankAdminService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { routes } from "../../routes/Routes";

const RoleLoginSuperAdmin = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinishHandle = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
            };
            const res = await _BankAdminService.bankAdminLogin(reqObj);
            if (res?.data?.IsSuccess) {
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                localStorage.setItem("IsBankAdminFlag", JSON.stringify(true));
                localStorage.setItem("BankAdminEmailId", res?.data?.Obj?.Email);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.Id);
                localStorage.setItem("BankAdminFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsFromNewLoginPage", routes.roleLoginSuperAdmin.path);
                history.push(routes.bankadmindashboard.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push({ pathname: routes.forgotBankerLoginPasswordSendOTP.path, state: { isFromBankAdmin: true, fromNewLoginPage: routes.roleLoginSuperAdmin.path } });
    };

    const createNewAccount = () => {
        history.push({ pathname: routes.createBankAdminAccount.path, state: { fromNewLoginPage: routes.roleLoginSuperAdmin.path } });
    };

    return (
        <Spin spinning={loading}>
            <RoleLoginForm
                title="Super Admin Portal"
                onFinishHandle={onFinishHandle}
                forgotPassword={forgotPassword}
                isNewAccountCreateFlag={true}
                createNewAccount={createNewAccount}
                onBack={() => history.push(routes.loginNewPage.path)}
            />
        </Spin>
    );
};

export default RoleLoginSuperAdmin;
